import RegionModel from 'Models/RegionModel';

/**
 * При изменение файла редактируйте бэкенд:
 * @see \App\Types\Enums\PaymentMethodsEnum::getMobileConfig
 */
const PaymentSystemModel = {};

// eslint-disable-next-line max-len
PaymentSystemModel.STRIPE_PUBLIC_KEY = process.env.STRIPE_TOKEN_PUB_DEVAL;
// mutates in MainApp.vue
PaymentSystemModel.STRIPE_RADAR_FIX_COMMISION = {
  [RegionModel.USA.id]: 0.08,
  [RegionModel.EU.id]: 0.07,
};

PaymentSystemModel.CATEGORIES = {
  bankCard: 'bank card',
  other: 'other method',
  crypto: 'crypto',
};

PaymentSystemModel.NONE = {
  id: null,
  title: 'None',
};

PaymentSystemModel.DECTA = {
  id: 1,
  title: 'Card',
};

PaymentSystemModel.PAYPAL = {
  id: 2,
  title: 'Paypal',
};

PaymentSystemModel.CARDPAY = {
  id: 3,
  title: 'Visa/MC (CardPay)',
};

PaymentSystemModel.XPATE = {
  id: 4,
  title: 'Xpate',
};

PaymentSystemModel.STRIPE = {
  id: 5,
  title: 'Stripe',
};

PaymentSystemModel.PAYMENTWALL = {
  id: 6,
  title: 'Paymentwall',
  fullRefundOnly: true,
};

PaymentSystemModel.CAPITALIST_CARD = {
  id: 7,
  title: 'Capitalist card',
};

PaymentSystemModel.CAPITALIST_WM = {
  id: 14,
  title: 'Capitalist wm',
};

PaymentSystemModel.CARDPAY_2_WEBMONEY = {
  id: 15,
  title: 'Cardpay webmoney',
};

PaymentSystemModel.EXTERNAL_PAID = {
  id: 16,
  title: 'EXTERNAL_PAID',
};

PaymentSystemModel.CARDPAY_2_CARD = {
  id: 17,
  title: 'Visa/MC (CardPay to Card)',
};

PaymentSystemModel.SKRILL = {
  id: 18,
  title: 'Skrill',
};

PaymentSystemModel.CARDPAY_2_BITCOIN = {
  id: 19,
  title: 'Bitcoin',
};

PaymentSystemModel.CARDPAY_2_QIWI = {
  id: 20,
  title: 'Cardpay_2 QIWI',
};

// Capitalist
PaymentSystemModel.USDT = {
  id: 21,
  title: 'Capitalist USDT_TRC20',
};

PaymentSystemModel.CAPITALIST = {
  id: 22,
  title: 'Capitalist internal',
};

PaymentSystemModel.CRYPTOLOGY = {
  id: 23,
  title: 'Cryptology USDT_TRC20',
};

PaymentSystemModel._4DEV = {
  id: 24,
  title: '4dev',
};

PaymentSystemModel.ECOMMPAY = {
  id: 25,
  title: 'EcomMpay',
};

PaymentSystemModel.CRYPTOPAY = {
  id: 26,
  title: 'Cryptopay USDT_TRC20',
};

PaymentSystemModel.INXY = {
  id: 27,
  title: 'Crypto',
};

PaymentSystemModel.SEZZLE = {
  id: 28,
  title: 'Sezzle',
};

PaymentSystemModel.EPOCH = {
  id: 29,
  title: 'Epoch',
};

PaymentSystemModel.PAYPAL_CARD = {
  id: 30,
  title: 'Paypal Card',
};

PaymentSystemModel.CHECKOUT = {
  id: 31,
  title: 'Checkout',
};

PaymentSystemModel.INXY_USDT_BEP20 = {
  id: 32,
  title: 'INXY USDT_BEP20',
};

PaymentSystemModel.CRYPTOLOGY_USDT_BEP20 = {
  id: 33,
  title: 'Cryptology USDT_BEP20',
};

PaymentSystemModel.GARNA = {
  id: 34,
  title: 'Garna',
};

PaymentSystemModel.METHODS = {};

// иды методов обязаны продолжать иды платежек! На бэкенде это все один список.
PaymentSystemModel.METHODS.PAYPAL_CARD = {
  id: PaymentSystemModel.PAYPAL_CARD.id,
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (Paypal)',
  enabled: true,
  mulModifier: 3.9, // %. При изменении, поправь здесь: PaypalDriver::PAYIN_CARD_COMMISSION_PERCENT
  baseCommission: 0.99,
  firstPurchaseMulModifier: 0,
  // onlyForUsersWithId: [137061, 200488],
  regions: [
    RegionModel.USA.id,
  ],
  hiddenForCustomSale: true,
};

PaymentSystemModel.METHODS.PAYPAL = {
  id: PaymentSystemModel.PAYPAL.id,
  pic: 'pay-pal.svg',
  title: 'PayPal',
  selectorCaption: 'Paypal is currently unavailable, please contact support',
  enabled: true,
  // onlyForUsersWithId: [4, 6, 52993], // todo @task SKY-1621 это временно
  mulModifier: 5.9, // %. При изменении, поправь здесь: PaypalDriver::PAYIN_CARD_COMMISSION_PERCENT
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
  hiddenForCustomSale: true,
};

PaymentSystemModel.METHODS.CARD = {
  id: PaymentSystemModel.STRIPE.id,
  pic: 'visa-and-mastercard.svg',
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (Stripe)',
  subtitle: 'Powered by Stripe',
  enabled: true,
  mulModifier: 3.9, // %. При изменении, поправь здесь: StripeDriver::PAYIN_CARD_COMMISSION_PERCENT
  baseCommission: 0.99,
  firstPurchaseMulModifier: 0, // %. При изменении, поправь здесь: StripeDriver::PAYIN_FIRST_PURCHASE_CARD_COMMISSION_PERCENT
  regions: [
    RegionModel.EU.id,
    RegionModel.USA.id,
  ],
};

PaymentSystemModel.METHODS.CARD_EU = {
  id: PaymentSystemModel.CARDPAY_2_CARD.id,
  pic: 'visa-and-mastercard.svg',
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (CardPay)',
  enabled: false,
  mulModifier: 4, // %
  firstPurchaseMulModifier: 0, // %
  regions: [
    RegionModel.EU.id,
    RegionModel.USA.id,
  ],
};

PaymentSystemModel.METHODS.APPLE_PAY = {
  id: 8,
  pic: 'apple-pay.svg',
  title: 'Apple Pay',
  enabled: false, // По дефолту должен быть всегда выключен. Включается только через логику в компонентах,
  mobileOnly: false,
  mulModifier: 3.9, // %
  baseCommission: 0.99,
  firstPurchaseMulModifier: 0, // %
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.GOOGLE_PAY = {
  id: 9,
  pic: 'google-pay.svg',
  title: 'Google Pay',
  enabled: false, // По дефолту должен быть всегда выключен. Включается только через логику в компонентах
  mobileOnly: false,
  onlyForUsersWithId: false, // false or [user.id, ...]
  mulModifier: 3.9, // %
  baseCommission: 0.99,
  firstPurchaseMulModifier: 0, // %
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.SOFORT = {
  id: 10,
  pic: 'sofort.svg',
  title: 'Sofort',
  enabled: false,
  regions: [
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.EPS = {
  id: 11,
  pic: 'eps.svg',
  title: 'EPS',
  enabled: false,
  regions: [
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.GIROPAY = {
  id: 12,
  pic: 'giropay.svg',
  title: 'Giropay',
  enabled: false,
  regions: [
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.IDEAL = {
  id: 13,
  pic: 'ideal.svg',
  title: 'iDEAL',
  enabled: false, // stripe suspended ideal
  regions: [
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.EXTERNAL_PAID = {
  id: PaymentSystemModel.EXTERNAL_PAID.id,
  pic: '',
  title: 'EXTERNAL_PAID',
  adminTitle: 'External paid',
  enabled: false,
  regions: [
    RegionModel.EU.id,
    RegionModel.USA.id,
  ],
};

PaymentSystemModel.METHODS.WEBMONEY = {
  id: PaymentSystemModel.CARDPAY_2_WEBMONEY.id,
  pic: 'webmoney.svg',
  title: 'Webmoney',
  enabled: false,
  onlyForUsersWithId: [3, 6], // todo @task SKY-1621 это временно
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.QIWI = {
  id: PaymentSystemModel.CARDPAY_2_QIWI.id,
  pic: 'qiwi.svg',
  title: 'QIWI',
  enabled: false,
  onlyForUsersWithId: [1, 3, 6],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.BITCOIN = {
  id: PaymentSystemModel.CARDPAY_2_BITCOIN.id,
  pic: 'bitcoin.svg',
  title: 'Bitcoin',
  enabled: true,
  onlyForUsersWithId: [1, 3, 6, 76018],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.SKRILL = {
  id: PaymentSystemModel.SKRILL.id,
  pic: 'skrill.svg',
  title: 'iDeal, Klarna, Neteller, Przelewy24, Rapid Transfer, Skrill Digital Wallet',
  adminTitle: 'Skrill',
  enabled: true,
  mulModifier: 5.9, // %. При изменении, поправь здесь: SkrillDriver::PAYIN_COMMISSION_PERCENT
  // onlyForUsersWithId: [3, 6, 1],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.ECOMMPAY = {
  id: PaymentSystemModel.ECOMMPAY.id,
  pic: 'ecommpay.svg',
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (Ecommpay)',
  subtitle: 'Powered by Ecommpay',
  enabled: true,
  mulModifier: 3.9, // %
  baseCommission: 0.99,
  onlyForUsersWithId: false,
  // onlyForUsersWithId: [4, 6, 52993, 54637, 126642, 137061],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.PAYMENTWALL = {
  id: PaymentSystemModel.PAYMENTWALL.id,
  pic: 'paymentwall.svg',
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (Paymentwall)',
  subtitle: 'Powered by Paymentwall',
  enabled: true,
  // onlyForUsersWithId: false,
  onlyForUsersWithId: [137061, 180974],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.INXY = {
  id: PaymentSystemModel.INXY.id,
  pic: 'inxy_payment.svg',
  title: 'BTC, ETH, USDT, USDC and more',
  adminTitle: 'INXY USDT_TRC20 ',
  subtitle: '',
  enabled: true,
  mulModifier: 5.9, // %
  // onlyForUsersWithId: false,
  // onlyForUsersWithId: [137061],
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.SEZZLE = {
  id: PaymentSystemModel.SEZZLE.id,
  pic: 'sezzle.svg',
  title: 'Pay now only 25% of the amount and split the remaining into several payments',
  adminTitle: 'Sezzle',
  subtitle: '',
  mulModifier: 5.9,
  enabled: true,
  // onlyForUsersWithId: [
  //   137061, // PROD USER
  //   // 200089, // PREPROD USER
  // ],
  minValue: 30,
  maxValue: 2500,
  regions: [
    RegionModel.USA.id,
  ],
  regionsCode: [
    // 'FI',
    'US',
  ],
};

PaymentSystemModel.METHODS.EPOCH = {
  id: PaymentSystemModel.EPOCH.id,
  pic: 'epoch.svg',
  picTitle: 'epoch-paypal.svg',
  title: 'PayPal powered by Epoch',
  adminTitle: 'Epoch (PayPal)',
  subtitle: '',
  mulModifier: 5.9,
  enabled: true,
  maxValue: 250,
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.METHODS.CHECKOUT = {
  id: PaymentSystemModel.CHECKOUT.id,
  title: 'Visa or Mastercard',
  adminTitle: 'Visa/MC (Checkout)',
  subtitle: '',
  mulModifier: 3.9,
  baseCommission: 0.99,
  firstPurchaseMulModifier: 0,
  enabled: true,
  regions: [
    RegionModel.USA.id,
    RegionModel.EU.id,
  ],
};

PaymentSystemModel.ID_TO_DATA = {
  [PaymentSystemModel.NONE.id]: PaymentSystemModel.NONE,
  [PaymentSystemModel.DECTA.id]: PaymentSystemModel.DECTA,
  [PaymentSystemModel.PAYPAL.id]: PaymentSystemModel.PAYPAL,
  [PaymentSystemModel.PAYPAL_CARD.id]: PaymentSystemModel.PAYPAL_CARD,
  [PaymentSystemModel.CARDPAY.id]: PaymentSystemModel.CARDPAY, // cardpay
  [PaymentSystemModel.CARDPAY_2_CARD.id]: PaymentSystemModel.CARDPAY_2_CARD, // cardpay_2
  [PaymentSystemModel.CARDPAY_2_WEBMONEY.id]: PaymentSystemModel.CARDPAY_2_WEBMONEY, // cardpay_2
  [PaymentSystemModel.CARDPAY_2_BITCOIN.id]: PaymentSystemModel.CARDPAY_2_BITCOIN, // cardpay_2
  [PaymentSystemModel.CARDPAY_2_QIWI.id]: PaymentSystemModel.CARDPAY_2_QIWI, // cardpay_2
  [PaymentSystemModel.XPATE.id]: PaymentSystemModel.XPATE,
  [PaymentSystemModel.STRIPE.id]: PaymentSystemModel.STRIPE,
  [PaymentSystemModel.PAYMENTWALL.id]: PaymentSystemModel.PAYMENTWALL,
  [PaymentSystemModel.CAPITALIST_CARD.id]: PaymentSystemModel.CAPITALIST_CARD,
  [PaymentSystemModel.CAPITALIST_WM.id]: PaymentSystemModel.CAPITALIST_WM,
  [PaymentSystemModel.USDT.id]: PaymentSystemModel.USDT,
  [PaymentSystemModel.CAPITALIST.id]: PaymentSystemModel.CAPITALIST,
  [PaymentSystemModel.CRYPTOLOGY.id]: PaymentSystemModel.CRYPTOLOGY,
  [PaymentSystemModel.CRYPTOPAY.id]: PaymentSystemModel.CRYPTOPAY,
  [PaymentSystemModel._4DEV.id]: PaymentSystemModel._4DEV,
  [PaymentSystemModel.ECOMMPAY.id]: PaymentSystemModel.ECOMMPAY,
  [PaymentSystemModel.METHODS.PAYPAL.id]: PaymentSystemModel.METHODS.PAYPAL,
  [PaymentSystemModel.METHODS.PAYPAL_CARD.id]: PaymentSystemModel.METHODS.PAYPAL_CARD,
  [PaymentSystemModel.METHODS.CARD.id]: PaymentSystemModel.METHODS.CARD,
  [PaymentSystemModel.METHODS.CARD_EU.id]: PaymentSystemModel.METHODS.CARD_EU,
  [PaymentSystemModel.METHODS.APPLE_PAY.id]: PaymentSystemModel.METHODS.APPLE_PAY,
  [PaymentSystemModel.METHODS.GOOGLE_PAY.id]: PaymentSystemModel.METHODS.GOOGLE_PAY,
  [PaymentSystemModel.METHODS.SOFORT.id]: PaymentSystemModel.METHODS.SOFORT,
  [PaymentSystemModel.METHODS.EPS.id]: PaymentSystemModel.METHODS.EPS,
  [PaymentSystemModel.METHODS.GIROPAY.id]: PaymentSystemModel.METHODS.GIROPAY,
  [PaymentSystemModel.METHODS.IDEAL.id]: PaymentSystemModel.METHODS.IDEAL,
  [PaymentSystemModel.METHODS.EXTERNAL_PAID.id]: PaymentSystemModel.METHODS.EXTERNAL_PAID,
  [PaymentSystemModel.METHODS.SKRILL.id]: PaymentSystemModel.METHODS.SKRILL,
  [PaymentSystemModel.METHODS.ECOMMPAY.id]: PaymentSystemModel.METHODS.ECOMMPAY,
  [PaymentSystemModel.METHODS.INXY.id]: PaymentSystemModel.METHODS.INXY,
  [PaymentSystemModel.METHODS.SEZZLE.id]: PaymentSystemModel.METHODS.SEZZLE,
  [PaymentSystemModel.METHODS.EPOCH.id]: PaymentSystemModel.METHODS.EPOCH,
  [PaymentSystemModel.METHODS.CHECKOUT.id]: PaymentSystemModel.METHODS.CHECKOUT,
  [PaymentSystemModel.INXY_USDT_BEP20.id]: PaymentSystemModel.INXY_USDT_BEP20,
  [PaymentSystemModel.CRYPTOLOGY_USDT_BEP20.id]: PaymentSystemModel.CRYPTOLOGY_USDT_BEP20,
  [PaymentSystemModel.GARNA.id]: PaymentSystemModel.GARNA,
};

PaymentSystemModel.LIST_PAYMENT_SYSTEMS = [
  PaymentSystemModel.EPOCH,
  PaymentSystemModel.PAYPAL,
  PaymentSystemModel.PAYPAL_CARD,
  PaymentSystemModel.STRIPE,
  PaymentSystemModel.ECOMMPAY,
  PaymentSystemModel.CHECKOUT,
  PaymentSystemModel.METHODS.APPLE_PAY,
  PaymentSystemModel.METHODS.GOOGLE_PAY,
  PaymentSystemModel.SKRILL,
  PaymentSystemModel.INXY,
  PaymentSystemModel.SEZZLE,
  PaymentSystemModel.EXTERNAL_PAID,
];

PaymentSystemModel.LIST_PAYOUT_SYSTEMS = [
  PaymentSystemModel.CARDPAY_2_CARD,
  PaymentSystemModel.CRYPTOLOGY,
  PaymentSystemModel.CRYPTOLOGY_USDT_BEP20,
  PaymentSystemModel._4DEV,
  PaymentSystemModel.INXY,
  PaymentSystemModel.INXY_USDT_BEP20,
  PaymentSystemModel.GARNA,
];

PaymentSystemModel.METHODS_LIST = [
  PaymentSystemModel.METHODS.PAYPAL,
  PaymentSystemModel.METHODS.CARD_EU,
  PaymentSystemModel.METHODS.CARD,
  PaymentSystemModel.METHODS.APPLE_PAY,
  PaymentSystemModel.METHODS.GOOGLE_PAY,
  PaymentSystemModel.METHODS.EPS,
  PaymentSystemModel.METHODS.GIROPAY,
  PaymentSystemModel.METHODS.IDEAL,
  // PaymentSystemModel.METHODS.WEBMONEY,
  PaymentSystemModel.METHODS.SKRILL,
  PaymentSystemModel.METHODS.BITCOIN,
  // PaymentSystemModel.METHODS.QIWI,
  PaymentSystemModel.METHODS.ECOMMPAY,
  PaymentSystemModel.METHODS.PAYMENTWALL,
  PaymentSystemModel.METHODS.INXY,
  PaymentSystemModel.METHODS.SEZZLE,
  PaymentSystemModel.METHODS.EPOCH,
  PaymentSystemModel.METHODS.CHECKOUT,
];

PaymentSystemModel.LIST_ALL = [
  PaymentSystemModel.NONE,
  PaymentSystemModel.DECTA,
  PaymentSystemModel.PAYPAL,
  PaymentSystemModel.CARDPAY,
  PaymentSystemModel.XPATE,
  PaymentSystemModel.STRIPE,
  PaymentSystemModel.PAYMENTWALL,
  PaymentSystemModel.METHODS.SOFORT,
  PaymentSystemModel.ECOMMPAY,
  ...PaymentSystemModel.METHODS_LIST,
];

PaymentSystemModel.STRIPE_METHODS_LIST = [
  PaymentSystemModel.STRIPE.id,
  PaymentSystemModel.METHODS.GOOGLE_PAY.id,
  PaymentSystemModel.METHODS.APPLE_PAY.id,
];

PaymentSystemModel.APP_NATIVE_METHODS_LIST = [
  PaymentSystemModel.METHODS.GOOGLE_PAY.id,
  PaymentSystemModel.METHODS.APPLE_PAY.id,
];

PaymentSystemModel.METHODS_WITH_BLOCKED_REFUND = [
  PaymentSystemModel.METHODS.EXTERNAL_PAID.id,
  PaymentSystemModel.METHODS.SEZZLE.id,
  PaymentSystemModel.METHODS.EPOCH.id,
  PaymentSystemModel.METHODS.PAYPAL_CARD,
];

PaymentSystemModel.COUNTRY_PAYMENT_ROUTING = {
  // Countries that should use Stripe instead of Ecommpay
  STRIPE_PREFERRED_COUNTRIES: [
    'TR', // Turkey
    'AL', // Albania
    // Add more countries here that should use Stripe
  ],
};

export default PaymentSystemModel;
